import { render } from "./ControlDate.vue?vue&type=template&id=52207e8b"
import script from "./ControlDate.vue?vue&type=script&lang=js"
export * from "./ControlDate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__